<template>
  <div class="cms_w">
    <div class="content_w bc_FAFAFA">
      <div class="site_content d_flex">
        <div class="side_menu_w bc_fff">
          <div >
            <!-- 栏目标题 -->
            <div class="directory_i">
              <img :src="cmsNode.icon" alt="" />
              <span class="node-title fz16 c_fff">{{ cmsNode.name || cmsNodeChild.name}}</span>
            </div>

            <!-- 子栏目菜单 -->
            <div
              v-for="item in cmsNode.children"
              :key="item.id"
              class="menu_i_w"
              @click="onNodeClick(item)"
            >
              <div
                class="menu_i c333 fz16"
                :class="Number(cmsNodeChild.id) === item.id ? 'c_0983CC' : ''"
              >
                <span>></span>
                <span class="child-node-title">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 详情 -->
        <div ref="mainRef" class="cms_info_w bc_fff">
          <div
            class="head fz12 c_1A1A1A d_flex justify_content_sb"
          >
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item v-if="hasCmsNode">{{ cmsNode.name }}</el-breadcrumb-item>
              <el-breadcrumb-item
                v-if="hasCmsNodeChild"
                :to="cmsNodeChild.nodeModel.route + '/' + cmsNodeChild.id"
                >{{ cmsNodeChild.name }}</el-breadcrumb-item
              >
              <el-breadcrumb-item class="div_3 text_ellipsis">{{
                "详情" || detailData.title
              }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>

          <div  class="info_c_w">
            <div class="text_center">
              <h2 class="article-title fz18 font_w_bold c_121212">
                {{ detailData.title }}
              </h2>
              <div class="article-meta fz14 c_A8A8A8">
                <span class="article-source"
                  >来源：{{ detailData.source || "本站" }}</span
                >
                <span>发布时间：{{ detailData.createdAt }}</span>
              </div>
              <div class="dashed_line" />
            </div>
            <div class="content_w" v-html="detailData.content" />

            <el-button
              v-if="
                ['ghxkgsgg', 'lxxd', 'jsxm', 'ghbz', 'ghgg'].includes(
                  cmsNodeChild.code
                )
              "
              class="feedback_btn d_flex"
              size="small"
              type="primary"
              @click="onFeedbackClick"
              >意见征集</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cms_article_info } from "@/api/portal";
import { mapGetters } from "vuex";
import Cookies from "js-cookie";
import bus from "@/utils/bus";
export default {
  name: "Async",
  metaInfo() {
    return {
      title: `${this.detailData?.title ? this.detailData.title + " - " : ""}${
        this.siteInfo?.name
      }`,
      meta: [
        {
          name: "keywords",
          content: this.detailData?.title,
        },
        {
          name: "description",
          content: this.detailData?.summary,
        },
      ],
    };
  },
  data() {
    return {
      detailData: {},
      cmsNode: {},
      cmsNodeChild: {},
    };
  },
  computed: {
    ...mapGetters(["siteInfo"]),
    id(){
      return this.$route.params.id
    },
    hasCmsNode(){
      return Object.keys(this.cmsNode).length
    },
    hasCmsNodeChild(){
      return Object.keys(this.cmsNodeChild).length
    }
  },
  watch: {
    // 详情数据
    detailData:{
      handler(n){
        if (n) {
          this.findNode(this.siteInfo.nodes);
        }
      },
      immediate:true
    },

    // 暴露栏目信息
    cmsNode(n) {
      if (n) {
        this.sendState();
      }
    },
  },
  created() {
    this.getArticleInfo();
  },

  methods: {
    // 获取文章详情 api
    async getArticleInfo() {
        const { data } = await cms_article_info({ id: this.id });
        this.detailData = data;
    },
    // 查询当前栏目节点和预览子节点
    findNode(nodes, parent) {
      if (nodes && nodes.length) {
        for (const i in nodes) {
          if (nodes[i].code === this.detailData.kind) {
            this.cmsNode = parent || {};
            this.cmsNodeChild = nodes[i] || {};
            console.log('156',this.cmsNode,this.cmsNodeChild)
            return;
          }
          if (nodes[i].children && nodes[i].children.length) {
            this.findNode(nodes[i].children, nodes[i]);
          }
        }
      }
    },
    // 暴露栏目信息
    sendState() {
      bus.$emit("getCmsNode", this.cmsNode);
      bus.$emit("getCmsNodeChild", this.cmsNodeChild);
    },
    // 征集意见 click
    onFeedbackClick() {
      this.$router.push({
        path: "/opinion_form",
        query: {
          id: this.id,
        },
      });
    },
    // 点击节点 click
    onNodeClick(item) {
      this.$router.push(this.cmsNode.nodeModel.route + '/' + item.id)
    }
  },
};
</script>

<style lang="scss" scoped>
.feedback_btn {
  margin: 10px auto;
}
::v-deep .el-breadcrumb {
  font-size: 15px;
}
.cms_info_w {
  overflow: auto;
  position: relative;
  flex: 1;
  // max-height: 1260px;
  padding: 0;
  border: 1px solid #e6e6e6;
  &::-webkit-scrollbar {
    display: none;
  }
  & {
    scrollbar-width: none; //火狐
  }
  .head {
    // position: absolute;
    width: 100%;
    padding: 19px 20px;
    background: #e6e6e6;
  }
  .info_c_w {
  }
  .content_w {
    padding: 39px 20px 50px 20px;
    ::v-deep p {
      // font-size: 14px;
      // color: #1a1a1a;
    }
  }
  .article-title {
    padding: 32px 0 28px 0;
  }
  .article-meta {
    margin: 0 0 31px 0;
  }
  .div_3 {
    width: 450px;
    ::v-deep img {
      cursor: initial;
    }
  }


}

.cms_w {
  margin: 20px 0;
  padding-top: 15px;
  .content_w {
    margin: 0 auto;
  }
  .side_menu_w {
    width: 216px;
    height: 100%;
    border: 1px solid #dbdbdb;
    margin: 0 10px 0 0;
    .directory_i {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 20px;
      background-color: #0983cc;
    }
    .menu_i {
      display: flex;
      align-items: flex-start;
      padding: 17px 0 17px 20px;
      cursor: pointer;
      border-bottom: 1px solid #e6e6e6;
    }

    .menu_i_w{
      &:last-child {
        .menu_i{
          border-bottom: 0;
        }
      }
    }

  }
  .node-title{
    margin: 0 0 0 8px;
  }
  .article-source {
    margin: 0 8px;
  }
  .child-node-title {
    margin: 0 0 0 20px;
  }
}
</style>
